import { DatePicker, Form } from 'antd';
import styled from 'styled-components';
import dayjs from 'dayjs';
import TimeTrackerTable from './TimeTrackerTable';
import TimeTrackerPrintPreview from './TimeTrackerPrintPreview';
import IcCalendarSelect from './IcCalendarSelect';
import Box from 'components/Box';
import Button from 'components/Button';
import { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Modal from 'components/Modal';
import Text from 'components/Text';
import shopSelectors from 'services/shop/selectors';

const customFormat = 'ddd, MM-DD-YYYY';

const RightTimeTracker = () => {
  const [showPreview, setShowPreview] = useState(false);
  const printRef = useRef<HTMLDivElement>(null);
  const shopInfo = shopSelectors.data.shopInfo();

  const formatDate = (date: dayjs.Dayjs | null) => {
    if (!date) return '';
    const today = dayjs();
    const isToday = date.isSame(today, 'day');
    if (isToday) {
      return 'Today, ' + date.format('MM-DD-YYYY');
    }
    return date.format(customFormat);
  };

  const onPrint = useReactToPrint({
    content: () => printRef.current,
    copyStyles: true,
  });

  const handleReview = () => {
    setShowPreview(true);
  };

  const handlePrint = () => {
    onPrint();
  };

  return (
    <RightBox>
      <Box display='flex' justifyContent='space-between' alignItems='center' pt='2' style={{ width: '100%' }}>
        <Form.Item name='date' style={{ width: '230px', marginBottom: 0 }}>
          <DatePicker
            format={formatDate}
            bordered={false}
            className='date-picker'
            rootClassName='date-picker-root'
            allowClear={false}
            suffixIcon={<IcCalendarSelect />}
          />
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const staffId = getFieldValue('staffId');
            const isStaffSelected = !!staffId;
            
            return (
              <ButtonGroup>
                <Button 
                  ntype="SECONDARY" 
                  icon="print" 
                  onClick={handleReview}
                  disabled={!isStaffSelected}
                  style={{ height: 'auto', padding: '8px 16px' }}
                >
                  Review
                </Button>
                <Button 
                  ntype="SECONDARY" 
                  icon="print" 
                  onClick={handlePrint}
                  disabled={!isStaffSelected}
                  style={{ height: 'auto', padding: '8px 16px' }}
                >
                  Print
                </Button>
              </ButtonGroup>
            );
          }}
        </Form.Item>
      </Box>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const date = getFieldValue('date');
          const dataFormat = dayjs(date).format('MM-DD-YYYY');
          const staffId = getFieldValue('staffId');
          return <TimeTrackerTable date={dataFormat} staffId={staffId} />;
        }}
      </Form.Item>

      <Modal
        visible={showPreview}
        onClose={() => setShowPreview(false)}
        width={356}
        v2
        hiddenHeader
        noneBodyStyle={true}
        footer={
          <Box display="flex" gap="2" justifyContent="center" width="100%">
            <Button 
              onClick={() => setShowPreview(false)}
              style={{ flex: 1, height: '40px' }}
            >
              Close
            </Button>
            <Button 
              icon="print" 
              onClick={onPrint}
              style={{ flex: 1, height: '40px' }}
            >
              Print
            </Button>
          </Box>
        }
      >
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const date = getFieldValue('date');
            const dataFormat = dayjs(date).format('MM-DD-YYYY');
            const staffId = getFieldValue('staffId');
            
            return (
              <PrintContainer ref={printRef}>
                <TimeTrackerPrintPreview date={dataFormat} staffId={staffId} />
              </PrintContainer>
            );
          }}
        </Form.Item>
      </Modal>
    </RightBox>
  );
};

export default RightTimeTracker;

const RightBox = styled.div`
  padding: 0 0.75rem 1rem 1rem;
  display: flex;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  flex-direction: column;
  gap: 1rem;
  .date-picker-root .ant-picker-input > input {
    color: #505050;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const PrintContainer = styled.div`
  background: white;
`;

